import artical1Cover from "../assets/images/articals/artical1.webp";
import artical2Cover from "../assets/images/articals/artical2.webp";
import artical3Cover from "../assets/images/articals/artical3.webp";
import artical4Cover from "../assets/images/articals/artical4.webp";

export const articles = [
  {
    id: "rb01",
    title: "From Lost Paths to Lines of Code: How My Non-Tech Life Led Me to Tech",
    slug: "non-tech-to-tech-journey-sep-2021",
    category: "Story",
    publishedDate: "September 2021",
    readTime: "20 min read",
    tags: [
      "Non-Tech to Tech Journey",
      "Creative Web Developer",
      "Career Transformation Story",
      "Inspiring Tech Journey",
      "Design and Logic Philosophy"
    ],
    thumbnail: artical1Cover,
    coverImage: artical1Cover,
    excerpt:
      "This is not just a career switch story. It’s a deeply personal journey through confusion, rejection, loneliness, creativity, and self-belief-showing how learning to code helped me design not just products, but my own life.",
    sections: [
      {
        type: "callout",
        style: "info",
        icon: "auto_stories",
        label: "Personal Story Archive",
        content:
          "This story is for those who feel late in life, behind others, or disconnected from their true potential. It is written for people who tried to do everything ‘right’ and still felt wrong inside. What you are about to read is not a highlight reel-it is a raw account of uncertainty, fear, wrong decisions, silent suffering, and slow transformation. This journey from a non-technical background to becoming a web developer did not begin with confidence. It began with confusion, loneliness, and a deep desire to find meaning."
      },
      {
        type: "image",
        url: artical1Cover,
        caption: "From confusion and silence to clarity and creation",
        fullBleed: false
      },
      {
        type: "heading",
        level: 1,
        content: "A Life Without a Clear Direction"
      },
      {
        type: "paragraph",
        content:
          "I completed my Higher Secondary education in 2016, but instead of feeling excited about the future, I felt completely blank. There was no plan, no vision-only noise. Everyone around me seemed to be moving with confidence, while I was silently panicking inside. Relatives asked questions I couldn’t answer. Friends talked about dreams I didn’t have. Society never prepares you for the moment when you realize you don’t know who you are yet. I felt pressure from every direction-family expectations, financial reality, age, comparison, and the constant reminder that time was passing. I didn’t know what I wanted to become, but I knew I couldn’t stop. So I chose what sounded safe. I enrolled in an Amin Survey course, believing that stability would eventually give me clarity. But clarity never came. I stayed busy, but empty. Days passed, years passed, and deep inside I felt like I was living someone else’s life. That phase taught me one of the most painful lessons of my life: you can move forward every day and still feel completely lost."
      },
      {
        type: "heading",
        level: 2,
        content: "Civil Engineering: A Path I Forced Myself to Walk"
      },
      {
        type: "paragraph",
        content:
          "After completing the survey course, I got admission to Dumkal ITI College for a diploma in Civil Engineering. On paper, it was progress. People congratulated me. My family felt relieved. Society approved my choice. But inside, I felt nothing. The subjects didn’t excite me. The learning felt mechanical, repetitive, and disconnected from who I was. Every morning, I prepared myself mentally to attend classes I didn’t enjoy, convincing myself that passion was optional and discipline was everything. I believed quitting would make me weak. So I stayed. Over time, forcing myself into a path that didn’t align with my nature slowly drained my confidence. I stopped trusting my instincts. I stopped listening to my inner voice. That phase taught me a harsh truth: when you live a life designed by fear instead of honesty, you don’t fail loudly-you fade quietly."
      },
      {
        type: "heading",
        level: 2,
        content: "When Effort Isn’t Enough"
      },
      {
        type: "paragraph",
        content:
          "I completed my diploma believing that consistency and effort would eventually fix everything. But nothing changed internally. I enrolled at Karimpur Pannadevi College for a pass course, hoping this would finally reset my journey. Instead, life tested me in the most unfair way. Due to internal political issues, I was denied my admit card in my final year. No explanation. No solution. No closure. Years of effort ended abruptly. I felt powerless and humiliated. It wasn’t just an academic loss-it felt like my time, my patience, and my honesty had been stolen. That phase pushed me into isolation. I questioned my worth daily. But unknowingly, it also planted resilience inside me. I learned that life doesn’t always reward effort immediately, and sometimes survival itself is an achievement."
      },
      {
        type: "heading",
        level: 2,
        content: "The Corporate Reality Check"
      },
      {
        type: "paragraph",
        content:
          "With responsibilities increasing and no clear future, I needed financial independence. I joined PegasusWave Pvt. Ltd. as a Customer Executive. For seven months, my life followed a routine-calls, scripts, targets, pressure. I learned how corporate systems work, but I also learned how easily a person can feel invisible inside them. Every night, I returned home mentally exhausted, questioning my future. There was no creativity, no learning, no sense of ownership. I felt replaceable. Trapped. Slowly, self-doubt grew heavier. That phase taught me something critical: a job can pay your bills but still starve your soul if it doesn’t align with who you are."
      },
      {
        type: "stats",
        title: "Inner Struggle Metrics",
        gridCols: 3,
        data: [
          { label: "Years of Confusion", value: "5+", trend: "down" },
          { label: "Career Dead Ends", value: "Multiple", trend: "stable" },
          { label: "Desire for Change", value: "Unstoppable", trend: "up" }
        ]
      },
      {
        type: "heading",
        level: 2,
        content: "The Question That Changed Everything"
      },
      {
        type: "paragraph",
        content:
          "I always had ideas-business ideas, creative ideas-but ideas are painful when you can’t execute them. I wanted to build a website and an app, but I had no money to hire developers. One day, a friend casually said, ‘Why don’t you build it yourself?’ That sentence stayed with me. It scared me because I didn’t believe I was capable. But it also sparked curiosity. For the first time in years, I felt hope stronger than fear. That moment marked a shift-from waiting for life to change to deciding to take control."
      },
      {
        type: "heading",
        level: 2,
        content: "Falling in Love with Code, Slowly"
      },
      {
        type: "paragraph",
        content:
          "Learning to code was brutal at first. Errors everywhere. Nothing worked. I felt stupid, frustrated, and alone. But then small wins appeared. A layout rendered correctly. A button responded. A feature worked exactly as imagined. Those moments gave me something rare-visible progress. I realized I am a creative person. Design allowed me to express emotion visually, while logic trained my thinking. Coding became the bridge between imagination and structure. For the first time in my life, learning felt empowering instead of forced."
      },
      {
        type: "blockquote",
        author: "Rahul Biswas",
        title: "Self-Taught Web Developer",
        content:
          "Coding didn’t just give me a career. It gave me back my confidence, my voice, and my belief that I could still become someone."
      },
      {
        type: "heading",
        level: 2,
        content: "Searching for Structure"
      },
      {
        type: "paragraph",
        content:
          "YouTube and Google gave me access, but not direction. Too many tutorials. Too many opinions. Too much confusion. I realized passion without structure leads to burnout. I needed mentorship, discipline, and accountability-something that would push me even when motivation faded."
      },
      {
        type: "heading",
        level: 2,
        content: "Newton School: Where I Rebuilt Myself"
      },
      {
        type: "paragraph",
        content:
          "Joining Newton School changed everything. I learned web development, DSA, business communication, and confidence building. I faced over 30 mock interviews, solved hard problems, completed 100+ assignments, and worked on real projects. Every challenge broke my comfort zone. Every failure rebuilt my confidence. I wasn’t just learning to code-I was rebuilding myself."
      },
      {
        type: "list",
        title: "What This Phase Gave Me",
        ordered: false,
        items: [
          "Strong foundations in web development",
          "Problem-solving mindset through DSA",
          "Confidence built through repeated failure",
          "Belief that creativity and logic can coexist"
        ]
      },
      {
        type: "divider",
        style: "dashed"
      },
      {
        type: "heading",
        level: 2,
        content: "The First Job and a Message to You"
      },
      {
        type: "paragraph",
        content:
          "Getting my first job as a Web Developer wasn’t just employment-it was validation. Proof that it’s never too late. Proof that your background doesn’t define your future. Today, I believe technology is not just about code; it’s about empathy, design, and problem-solving. Creativity gives direction. Logic gives structure. Together, they build meaningful products-and meaningful lives. If you’re reading this and feel lost, remember: being lost is not failure. It’s the beginning of self-discovery. Start small. Stay curious. Keep going. Your path will reveal itself."
      }
    ]
  },
  {
    id: "rb02",
    title: "Life After Becoming a Developer: My First Job, Real Challenges, and Finding Purpose",
    slug: "life-after-becoming-a-developer-first-job",
    category: "Story",
    publishedDate: "March 2023",
    readTime: "18 min read",
    tags: [
      "First Developer Job",
      "Startup Life",
      "Web Developer Journey",
      "TechPax Experience",
      "Career Growth in Tech"
    ],
    thumbnail: artical2Cover,
    coverImage: artical2Cover,
    excerpt:
      "This is the story of my first job as a Web Developer at a startup-where theory met reality, creativity met deadlines, mistakes became teachers, and technology finally felt alive.",
    sections: [
      {
        type: "callout",
        style: "info",
        icon: "work_history",
        label: "Career Milestone",
        content:
          "This article documents one of the most important phases of my life-the transition from a learner to a professional. It captures the raw emotions of starting my first job, the fear of responsibility, the joy of building real products, and the people who made growth feel human. This phase taught me that becoming a developer is not just about writing code, but about learning how to think, communicate, fail, recover, and collaborate."
      },
      {
        type: "image",
        url: artical2Cover,
        caption: "Life After Becoming a Developer",
        fullBleed: false
      },
      {
        type: "heading",
        level: 1,
        content: "Stepping Into the Real World of Tech"
      },
      {
        type: "paragraph",
        content:
          "In March 2023, I stepped into the real world of technology as a Web Developer at TechPax, a growing startup in New Delhi. This moment carried years of emotional weight. I had spent so long doubting myself, questioning my choices, and wondering if I truly belonged in tech. Walking into the office for the first time felt surreal. I wasn’t entering as a student or a trainee anymore-I was entering as someone expected to contribute, to solve problems, and to take responsibility. Along with excitement came fear. Fear of making mistakes. Fear of not being good enough. Fear of being exposed as someone who only knew theory. Unlike tutorials, there were no predefined paths here. Real users, real systems, and real consequences awaited me. That realization was intimidating-but also deeply motivating."
      },
      {
        type: "heading",
        level: 2,
        content: "TechPax: More Than Just a Startup"
      },
      {
        type: "paragraph",
        content:
          "TechPax was not just another startup chasing growth-it was a space built on belief, experimentation, and trust. From my first few days, I sensed that this environment was different. There was no rigid hierarchy that silenced ideas. Conversations were open. Questions were welcomed. Curiosity was encouraged. It didn’t matter if you were new or experienced-what mattered was your willingness to think and contribute. I felt safe to admit when I didn’t know something. I felt supported when I made mistakes. That culture gave me permission to grow without fear. It taught me that the right environment can unlock potential faster than any course or certification ever could."
      },
      {
        type: "heading",
        level: 2,
        content: "Learning Beyond Code"
      },
      {
        type: "paragraph",
        content:
          "At TechPax, my learning expanded far beyond writing JavaScript or building interfaces. I was exposed to the full ecosystem of product development-web applications, UI design decisions, UX psychology, system design, algorithms, performance trade-offs, and user behavior. I learned that every technical choice has business implications, and every business decision affects architecture. I started understanding users not as abstract personas, but as real people with emotions, impatience, and expectations. Slowly, I realized that great software is not written for machines-it is designed for humans. This phase reshaped how I looked at technology. Code was no longer just syntax; it was communication."
      },
      {
        type: "heading",
        level: 2,
        content: "Real Challenges, Real Deadlines"
      },
      {
        type: "paragraph",
        content:
          "This job introduced me to pressure in its truest form. Deadlines were no longer flexible. Bugs could break real systems. A small mistake could affect many users. There were moments when features failed minutes before deployment, when systems behaved unpredictably, and when time worked against us. Late nights became part of the routine. But instead of panic, I felt ownership. For the first time, my work mattered beyond personal learning. I began to understand how the internet actually works-servers, networking issues, deployments, downtime, and scalability. These challenges didn’t weaken me; they sharpened me. They forced me to think clearly under stress and taught me that resilience is as important as intelligence in tech."
      },
      {
        type: "heading",
        level: 2,
        content: "Aman: A Leader Who Created Freedom"
      },
      {
        type: "paragraph",
        content:
          "Aman, the founder of TechPax, was not just a boss-he was a leader who understood people. He believed deeply in creativity and gave everyone the freedom to explore ideas without fear. His vision was clear, but his approach was flexible. He trusted his team fully. That trust created accountability naturally. Whether it was late-night problem-solving or sudden challenges, he ensured we were supported-emotionally and practically. He arranged everything needed to keep morale high, from food during late nights to spontaneous celebrations. Through him, I learned that leadership is not about authority; it’s about creating an environment where people want to give their best."
      },
      {
        type: "heading",
        level: 2,
        content: "Sangram: A Manager Who Simplified Growth"
      },
      {
        type: "paragraph",
        content:
          "Sangram played a deeply important role in my growth. He was more than a manager-he was a calm presence during chaos. When systems failed or pressure rose, he never reacted emotionally. He simplified problems, guided discussions, and ensured no one felt alone while facing challenges. His approach taught me that clarity is one of the most powerful tools in leadership. Watching him handle critical situations shaped my understanding of how technical maturity and emotional intelligence work together. He showed me that good managers don’t just manage work-they create confidence."
      },
      {
        type: "blockquote",
        author: "Rahul Biswas",
        title: "Web Developer at TechPax",
        content:
          "My first job taught me that behind every line of code is a human decision-and behind every system is a team trying their best."
      },
      {
        type: "heading",
        level: 2,
        content: "Late Nights, Team Bonding, and Startup Life"
      },
      {
        type: "paragraph",
        content:
          "Startup life at TechPax was intense, unpredictable, and deeply human. Late nights became moments of bonding. Shared pressure turned into shared laughter. After work, we celebrated small wins together-sometimes with food, sometimes with conversations that lasted longer than planned. Those moments taught me that growth doesn’t have to be lonely. Aman ensured that even during long hours, we felt cared for. That balance between responsibility and joy made work meaningful. These memories shaped my belief that strong teams are built not just through deadlines, but through shared experiences."
      },
      {
        type: "divider",
        style: "dashed"
      },
      {
        type: "heading",
        level: 2,
        content: "What This Phase Taught Me About Life and Tech"
      },
      {
        type: "paragraph",
        content:
          "My journey at TechPax shaped my philosophy as a developer and as a person. I learned that technology is not just about tools-it’s about responsibility, empathy, and collaboration. Deadlines teach discipline. Failures teach humility. Teams teach humanity. This phase showed me that choosing the right environment matters more than choosing the biggest brand. If you’re starting your first job, choose places that help you grow as a human being, not just as a professional. When people believe in you, you start believing in yourself-and that belief changes everything."
      }
    ]
  },
  {
    id: "rb03",
    title: "Delhi Days and Night Walks: How Friendship and Travel Taught Me to Live",
    slug: "delhi-lifestyle-friendship-travel-story",
    category: "Travel",
    publishedDate: "2023",
    readTime: "20 min read",
    tags: [
      "Delhi Lifestyle",
      "Travel With Friends",
      "Life in Delhi",
      "Friendship and Growth",
      "Personal Travel Story"
    ],
    thumbnail: artical3Cover,
    coverImage: artical3Cover,
    excerpt:
      "This is not a travel guide to Delhi. It’s a story of freedom, friendship, late nights, shared laughter, quiet healing, and how exploring a city helped me finally learn how to live.",
    sections: [
      {
        type: "callout",
        style: "info",
        icon: "location_city",
        label: "Life Chapter",
        content:
          "This chapter of my life is about movement-physical and emotional. It captures my days in Delhi, where the city, friendships, late-night walks, and small adventures slowly healed parts of me shaped by years of struggle. This is not about monuments or destinations. It is about how a city can become a teacher, and how people can turn unfamiliar streets into home."
      },
      {
        type: "image",
        url: artical3Cover,
        caption: "Friendship and Travel Taught Me to Live",
        fullBleed: false
      },
      {
        type: "heading",
        level: 1,
        content: "Arriving in Delhi: A New Chapter Begins"
      },
      {
        type: "paragraph",
        content:
          "When I arrived in Delhi, I didn’t just enter a new city-I entered a new version of myself. Everything felt larger than life. The roads were wider, the crowds louder, the dreams heavier. Delhi moved fast, and it didn’t wait for anyone to catch up. At first, I felt overwhelmed. I carried years of uncertainty, failure, and emotional exhaustion with me. But something about the city felt honest. No one cared where you came from. What mattered was how you moved forward. That anonymity felt freeing. I was no longer defined by my past mistakes. In Delhi, I was just another person trying to figure life out. That realization gave me quiet strength."
      },
      {
        type: "heading",
        level: 2,
        content: "Learning the Delhi Lifestyle"
      },
      {
        type: "paragraph",
        content:
          "Delhi life teaches you discipline and adaptability without ever announcing it. Days begin early. Metros are crowded. Time moves fast. But evenings stretch long, filled with chai, street food, conversations, and unplanned pauses. I learned how to manage money carefully, how to stretch limited resources, and how to survive independently. Shared rooms, simple meals, late dinners, and early mornings became routine. There was no luxury, but there was freedom. I learned that lifestyle is not about comfort-it’s about rhythm. Once I found my rhythm, Delhi stopped feeling intimidating and started feeling familiar. The city didn’t soften me; it strengthened me."
      },
      {
        type: "heading",
        level: 2,
        content: "Friends Who Turned a City Into Home"
      },
      {
        type: "paragraph",
        content:
          "What truly transformed my Delhi experience were the people I shared it with. Friends became family. After long workdays, we sat together talking about everything-dreams, failures, relationships, fears, and futures that felt both exciting and uncertain. There was no need to pretend. We were all figuring life out in our own ways. When you’re far from home, friendships become emotional anchors. These bonds weren’t built on convenience; they were built on shared struggles and mutual understanding. Delhi never felt lonely because I wasn’t walking its streets alone. I was growing alongside people who understood where I came from and believed in where I was going."
      },
      {
        type: "heading",
        level: 2,
        content: "Exploring Delhi: Not Tourists, But Explorers"
      },
      {
        type: "paragraph",
        content:
          "We didn’t explore Delhi like tourists with checklists-we explored it like explorers searching for moments. Late evenings at India Gate, slow walks through Connaught Place, chaotic lanes of Old Delhi, peaceful corners of Humayun’s Tomb-each place carried a different emotion. Sometimes we planned trips, sometimes we just wandered without direction. Street food tasted better when shared. Metro rides felt shorter with laughter. Photos never captured the feeling of being there together. Traveling with friends made every place meaningful. Delhi taught me that exploration doesn’t require money or plans-it requires curiosity, time, and people who make moments feel alive."
      },
      {
        type: "heading",
        level: 2,
        content: "Late Nights, Streets, and Honest Conversations"
      },
      {
        type: "paragraph",
        content:
          "Some of the most meaningful moments happened at night. After work, after deadlines, after exhaustion-we walked. The city felt different then. Quieter. Slower. Honest. Streetlights replaced noise. We talked about fears we never spoke out loud, doubts we carried silently, and dreams that scared us. Those late-night walks healed parts of me I didn’t know were broken. They taught me that growth doesn’t always happen during achievements-it happens during conversations, during silence, during shared vulnerability. Delhi nights taught me how to listen-to others and to myself."
      },
      {
        type: "heading",
        level: 2,
        content: "What Delhi Taught Me About Life"
      },
      {
        type: "paragraph",
        content:
          "Delhi taught me resilience. It taught me how to exist inside chaos without losing myself. The city showed me that clarity doesn’t come before movement-you build clarity while moving. I learned to accept uncertainty, to adapt quickly, and to trust my instincts. Delhi never promised comfort, but it rewarded courage. It taught me that growth is uncomfortable, but stagnation is far more painful. Living here reshaped my mindset. I became braver, more open, and more honest with myself."
      },
      {
        type: "blockquote",
        author: "Rahul Biswas",
        title: "Explorer of Life",
        content:
          "Delhi didn’t change me overnight. It slowly taught me how to live-with curiosity, courage, and people who made the journey meaningful."
      },
      {
        type: "divider",
        style: "dashed"
      },
      {
        type: "heading",
        level: 2,
        content: "A Message to the Reader"
      },
      {
        type: "paragraph",
        content:
          "If you’re reading this and feeling stuck, remember this: sometimes growth doesn’t come from planning-it comes from movement. New cities challenge you. New people reflect you. New experiences reshape you. Travel with people who make you feel safe enough to be honest. Walk streets that scare and excite you at the same time. Let life surprise you. Delhi was a phase, not a destination-but it gave me friendships, memories, and lessons that will stay with me forever. Wherever you are right now, trust that your journey is unfolding exactly as it should."
      }
    ]
  },
  {
    id: "rb04",
    title: "Lost Paths to Lines of Code: What Was Really Happening Inside Me",
    slug: "lost-paths-to-lines-of-code-inner-journey",
    category: "Story",
    publishedDate: "2024",
    readTime: "22 min read",
    tags: [
      "Self Discovery",
      "Mental Health Journey",
      "Non Tech to Tech",
      "Emotional Growth",
      "Developer Story"
    ],
    thumbnail: artical4Cover,
    coverImage: artical4Cover,
    excerpt:
      "This chapter is not about success or career growth. It is about loneliness, fear, depression, self-discovery, and the invisible battles I fought while becoming who I am today.",
    sections: [
      {
        type: "callout",
        style: "info",
        icon: "psychology",
        label: "Personal Reflection",
        content:
          "This chapter documents the part of my journey that rarely gets spoken about-the emotional cost of growth. It explores loneliness, fear, silent depression, and the inner conflicts that existed even while my external life seemed to improve. This is not advice. It is honesty."
      },
      {
        type: "image",
        url: artical4Cover,
        caption: "What Was Really Happening Inside Me",
        fullBleed: false
      },
      {
        type: "heading",
        level: 1,
        content: "When Progress Didn’t Feel Like Peace"
      },
      {
        type: "paragraph",
        content:
          "From the outside, everything looked fine. I had changed my career, entered tech, learned skills that once felt impossible, and started building a future people respected. Friends and family believed I had finally figured life out. But inside, nothing felt calm. Progress didn’t bring peace-it brought pressure. Each milestone carried a new fear. What if I fail here too? What if this stability disappears? What if I don’t deserve this life? These thoughts followed me silently, even during moments that were supposed to feel proud. I realized that escaping a difficult past does not automatically heal the emotional damage it leaves behind. I was moving forward externally while internally still carrying years of rejection, confusion, and self-doubt. I wasn’t broken-but I wasn’t healed either."
      },
      {
        type: "heading",
        level: 2,
        content: "Loneliness in a Life Full of People"
      },
      {
        type: "paragraph",
        content:
          "Loneliness doesn’t always come from isolation. Sometimes it exists in rooms full of people. During this phase, I talked, worked, laughed, and functioned normally-but felt deeply unseen. I didn’t speak about my struggles because I didn’t want to appear ungrateful or weak after coming so far. I believed strength meant silence. Nights were the hardest. My mind replayed past failures, imagined future losses, and compared my journey with others. Sleep became fragmented. Overthinking became routine. I learned that growth can isolate you when your emotional foundation hasn’t caught up with your progress. This loneliness wasn’t caused by lack of people-it came from lack of emotional permission to feel what I was feeling."
      },
      {
        type: "heading",
        level: 2,
        content: "Depression, Fear, and Quiet Battles"
      },
      {
        type: "paragraph",
        content:
          "Depression didn’t arrive dramatically. It entered quietly-through exhaustion, numbness, and emotional flatness. I still completed tasks. I still learned. I still showed up. But I wasn’t present. Fear lived constantly in the background. Fear of being exposed as not good enough. Fear of losing everything I had rebuilt. Fear of falling behind again. What made it heavier was guilt. I felt ashamed for struggling after finally making progress. That guilt deepened the silence. I learned something painful but important: depression does not care about achievements. It does not check your résumé. It simply exists. On days when belief disappeared, discipline carried me forward. I didn’t move because I felt strong-I moved because stopping felt more dangerous."
      },
      {
        type: "stats",
        title: "Inner Struggles During This Phase",
        gridCols: 3,
        data: [
          { label: "Mental Exhaustion", value: "High", trend: "up" },
          { label: "Self Doubt", value: "Constant", trend: "stable" },
          { label: "Inner Growth", value: "Slow but Real", trend: "up" }
        ]
      },
      {
        type: "heading",
        level: 2,
        content: "Working While Breaking Inside"
      },
      {
        type: "paragraph",
        content:
          "This was the hardest period of my journey-functioning while emotionally exhausted. Coding late at night with a tired mind. Learning new concepts while battling internal noise. Sometimes I stared at the screen not because the problem was complex, but because my thoughts were louder than my logic. There were days when I felt empty and mechanical. Yet I continued. Quietly. Not heroically. Every small win-a solved bug, a completed task, a feature that worked-became proof that I was still alive in the journey. This phase taught me a deeper definition of strength. Strength wasn’t motivation or confidence. It was continuing when nothing inside you felt supportive."
      },
      {
        type: "blockquote",
        author: "Rahul Biswas",
        title: "Self Reflection",
        content:
          "Some of the strongest moments of my life happened quietly, when no one was watching and I almost gave up."
      },
      {
        type: "heading",
        level: 2,
        content: "Friends Who Held Me Together"
      },
      {
        type: "paragraph",
        content:
          "I did not survive this phase alone. My friends didn’t solve my problems-but they made them bearable. Late-night conversations. Shared silence. Jokes when I needed distraction. Honest words when I needed grounding. They reminded me who I was when I forgot. Support didn’t arrive as advice-it arrived as presence. They stayed even when I was quiet, exhausted, and unsure. They didn’t rush my healing or judge my weakness. Their presence became a silent safety net. This phase taught me something essential: friendships don’t just add happiness to life-sometimes they quietly save it."
      },
      {
        type: "heading",
        level: 2,
        content: "Self-Discovery Through Pain"
      },
      {
        type: "paragraph",
        content:
          "Pain stripped away illusions. Through this phase, I learned my emotional limits, my triggers, and my real needs. I realized I am not just a developer-I am a creator who needs meaning, not just tasks. I learned that mental health is not optional; it is foundational. I stopped chasing perfection and started respecting progress. I stopped comparing timelines and started listening to my own pace. I didn’t become fearless-but I became honest. That honesty changed everything. I learned that healing does not mean the absence of pain-it means learning how to live with it without losing yourself."
      },
      {
        type: "list",
        title: "Invisible Achievements From This Phase",
        ordered: false,
        items: [
          "Continuing even when motivation disappeared",
          "Accepting vulnerability as strength",
          "Building emotional discipline",
          "Understanding myself beyond titles and skills",
          "Learning to ask for help without guilt"
        ]
      },
      {
        type: "divider",
        style: "dashed"
      },
      {
        type: "heading",
        level: 2,
        content: "A Message to You, If You’re Reading This"
      },
      {
        type: "paragraph",
        content:
          "If you are reading this and everything feels heavy-even after progress-please know this: you are not weak. You are transforming. Growth is not clean. Healing is not linear. Loneliness does not mean failure. Sometimes it means you are changing faster than your emotional world can process. Keep going. Slowly if needed. Especially slowly. Your story is unfolding even on days it feels stuck. I walked through this phase afraid, exhausted, and unsure-but I walked through it. And so can you."
      }
    ]
  }
];






























const articleSchema = [
  {
    id: 0,
    title: "",
    slug: "",
    category: "",
    publishedDate: "",
    readTime: "",
    tags: [],
    thumbnail: "",
    coverImage: "",
    excerpt: "",
    sections: [
      {
        type: "callout",
        style: "", // warning, info
        icon: "",
        label: "",
        content: ""
      },
      {
        type: "heading",
        level: 1, // 1 or 2
        content: ""
      },
      {
        type: "paragraph",
        content: ""
      },
      {
        type: "stats",
        title: "",
        gridCols: 3,
        data: [
          { label: "", value: "", trend: "" } // trend: up, stable, down
        ]
      },
      {
        type: "code",
        language: "",
        label: "", // e.g., Filename.js
        content: ""
      },
      {
        type: "image",
        url: "",
        caption: "",
        fullBleed: false
      },
      {
        type: "blockquote",
        author: "",
        title: "",
        content: ""
      },
      {
        type: "list",
        title: "",
        ordered: false,
        items: []
      },
      {
        type: "divider",
        style: "" // dashed, gradient
      }
    ]
  }
];